module.exports = __webpack_public_path__ + "img/notice-bvic-sc.dd0f40ea.jpeg";